<template>
        <global-dropdown v-if="dropdownOptions.length > 0" class="filter-select" :options="dropdownOptions" :initial-title="filter.title" :disabled="dropdownDisabled" @change="onSelectionChange" :multi-select="true" :theme="theme" />
</template>

<script>
    import GlobalDropdown from "@global/global-elements/global-dropdown/global-dropdown";

    export default {
        components: { GlobalDropdown },
        name: "sal-filter-groupedselect",
        props: {
            filter: {}
        },
        computed: {
            filtergroups() {
                const groups = []
                this.filter.selectiongroups.forEach(name => {
                    const group = this.$store.getters.filterByName(name)
                    if (group) {
                        groups.push(group)
                    }
                })
                return groups
            },

            dropdownOptions: function() {
                const options = []
                this.filtergroups.forEach(filter => {
                    const selectedValues = this.$store.getters.selectedFilters[filter.name] || []
                    const availableValues = this.$store.getters.getAvailableOptions[filter.name] || []

                    options.push({
                        key: filter.name,
                        title: filter.title,
                        selected: false,
                        disabled: availableValues.length <= 0,
                        style: 'group'
                    })

                    filter.options.forEach(option => {
                        // Required properties: key(unique), title; Other properties: disabled
                        const value = option.value ? option.value : value
                        options.push({
                            key: filter.name + '--' + value,
                            title: option.title ? option.title : option,
                            selected: selectedValues.includes(value),
                            disabled: !availableValues.includes(value),
                            style: 'nested'
                        })
                    })
                })

                return options
            },

            dropdownDisabled() {
                // Doppelt negiert: Sobald eins nicht deaktiviert ist, ist das disabled negiert.
                return !this.dropdownOptions.some(option => !option.disabled)
            },

            theme() {
                if (this.filter && (this.filter.name === 'sustain' || this.filter.name.startsWith('greentool_'))) {
                    return 'sustainable'
                }
                return 'secondary'
            }
        },
        methods: {
            onSelectionChange(changedOption) {
                this.select(changedOption.key, changedOption.disabled);
            },
            select(value, disabled) {
                if (!disabled) {
                    this.filtergroups.forEach(filter => {
                        // Values are prefixed with filter.name and "--"
                        if (value.indexOf(filter.name + "--") === 0) {
                            value = value.substring(filter.name.length + 2)
                            if (this.$store.getters.selectedFilters[filter.name]) {
                                const found = this.$store.getters.selectedFilters[filter.name].some(val => val === value);
                                if (found) {
                                    this.$store.dispatch('removeFilterState', {
                                        filterName: filter.name,
                                        value: value
                                    });
                                } else {
                                    this.$store.dispatch('setFilterState', {filterName: filter.name, value: value})
                                }
                            } else {
                                this.$store.dispatch('setFilterState', {filterName: filter.name, value: value})
                            }
                        }
                    })
                }
            }
        }
    }
</script>
